module.exports = __webpack_public_path__ + "static/media/collapsed.c1296b29.svg";